// Embeds
export const FACEBOOK_OEMBED_REGEX = '(https:\\/\\/www.facebook.com\\/.*\\/(posts|videos)\\/.*)';

export const YOUTUBE_EMBED_ENDPOINT = 'https://www.youtube-nocookie.com/embed';
export const TIKTOK_OEMBED_ENDPOINT = 'https://www.tiktok.com/oembed';
export const FACEBOOK_OEMBED_ENDPOINT = 'https://graph.facebook.com/v17.0/oembed_post';
export const INSTAGRAM_OEMBED_ENDPOINT = 'https://graph.facebook.com/v17.0/instagram_oembed';
